import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { So5FixtureEvent, Sport } from '__generated__/globalTypes';
import { useQuery } from 'hooks/graphql/useQuery';

import type {
  NoCardRoute,
  NoCardRouteVariables,
} from './__generated__/useNoCardRoute.graphql';

const QUERY = gql`
  query NoCardRoute($sport: Sport!, $eventType: So5FixtureEvent!) {
    config {
      id
      so5 {
        id
        noCardRoute(sport: $sport, eventType: $eventType) {
          id
          emailAddress
          nextOpenDate
          nextCloseDate
        }
      }
    }
  }
` as TypedDocumentNode<NoCardRoute, NoCardRouteVariables>;

interface Props {
  sport: Sport;
  eventType: So5FixtureEvent;
}

export const useNoCardRoute = ({ sport, eventType }: Props) => {
  const { data, loading } = useQuery(QUERY, {
    variables: { sport, eventType },
  });

  return {
    noCardRoute: data?.config?.so5?.noCardRoute || {
      nextOpenDate: new Date(),
      nextCloseDate: new Date(),
      emailAddress: 'football-entry@sorare.com',
    },
    loading,
  };
};
